import React, { useState } from 'react';
import { Plus, Trash2, Edit2, Check, X, Image as ImageIcon, Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const CampaignsManager = ({ campaigns, onChange, allProducts }) => {
    const { t } = useTranslation();
    const [editingId, setEditingId] = useState(null);
    const [formData, setFormData] = useState({});
    const [productSearchResults, setProductSearchResults] = useState([]);

    const handleCreate = () => {
        const newCampaign = {
            id: Date.now().toString(),
            title_en: "New Campaign",
            title_tr: "Yeni Kampanya",
            desc_en: "Description here",
            desc_tr: "Açıklama buraya",
            badge_en: "New",
            badge_tr: "Yeni",
            ctaText_en: "View Deal",
            ctaText_tr: "İncele",
            isActive: false,
            ctaUrl: "/all-product",
            startAt: "",
            endAt: ""
        };
        onChange([...campaigns, newCampaign]);
        setEditingId(newCampaign.id);
        setFormData(newCampaign);
    };

    const handleSave = () => {
        const updated = campaigns.map(c =>
            c.id === editingId ? formData : c
        );
        onChange(updated);
        setEditingId(null);
    };

    const handleDelete = (id) => {
        if (window.confirm(t('admin.messages.confirmDelete'))) {
            onChange(campaigns.filter(c => c.id !== id));
        }
    };

    const handleEdit = (c) => {
        setEditingId(c.id);
        setFormData({ ...c }); // clone
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    return (
        <div className="space-y-6">
            {!editingId && (
                <button
                    onClick={handleCreate}
                    className="w-full py-4 border-2 border-dashed border-gray-300 rounded-xl flex items-center justify-center gap-2 text-gray-500 hover:border-green-600 hover:text-green-600 transition-colors font-medium "
                >
                    <Plus className="w-5 h-5" />
                    {t('admin.homepage.campaigns.create')}
                </button>
            )}

            {editingId && (
                <div className="bg-white p-6 rounded-xl border border-green-200 shadow-sm space-y-4">
                    <h3 className="font-bold text-gray-800 border-b pb-2 mb-4">{t('admin.actions.edit')}</h3>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">TR Title</label>
                            <input
                                className="w-full p-2 border rounded"
                                value={formData.title_tr}
                                onChange={e => handleChange('title_tr', e.target.value)}
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">EN Title</label>
                            <input
                                className="w-full p-2 border rounded"
                                value={formData.title_en}
                                onChange={e => handleChange('title_en', e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">TR Description</label>
                            <textarea
                                className="w-full p-2 border rounded"
                                rows="2"
                                value={formData.desc_tr}
                                onChange={e => handleChange('desc_tr', e.target.value)}
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">EN Description</label>
                            <textarea
                                className="w-full p-2 border rounded"
                                rows="2"
                                value={formData.desc_en}
                                onChange={e => handleChange('desc_en', e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">TR Badge</label>
                            <input
                                className="w-full p-2 border rounded"
                                value={formData.badge_tr}
                                onChange={e => handleChange('badge_tr', e.target.value)}
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">EN Badge</label>
                            <input
                                className="w-full p-2 border rounded"
                                value={formData.badge_en}
                                onChange={e => handleChange('badge_en', e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">TR CTA Text</label>
                            <input
                                className="w-full p-2 border rounded"
                                value={formData.ctaText_tr || ''}
                                placeholder="İncele"
                                onChange={e => handleChange('ctaText_tr', e.target.value)}
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">EN CTA Text</label>
                            <input
                                className="w-full p-2 border rounded"
                                value={formData.ctaText_en || ''}
                                placeholder="View Deal"
                                onChange={e => handleChange('ctaText_en', e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Starts At</label>
                            <input
                                type="datetime-local"
                                className="w-full p-2 border rounded"
                                value={formData.startAt}
                                onChange={e => handleChange('startAt', e.target.value)}
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Ends At</label>
                            <input
                                type="datetime-local"
                                className="w-full p-2 border rounded"
                                value={formData.endAt}
                                onChange={e => handleChange('endAt', e.target.value)}
                            />
                        </div>
                    </div>



                    {/* Product Link Selection */}
                    <div className="border-t pt-4 mt-2">
                        <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Link to Product (Optional)</label>
                        {!formData.linkedProductId ? (
                            <div className="relative">
                                <Search className="absolute left-3 top-2.5 text-gray-400 w-4 h-4" />
                                <input
                                    type="text"
                                    placeholder="Search product to link..."
                                    className="w-full pl-9 p-2 border rounded text-sm"
                                    onChange={(e) => {
                                        const val = e.target.value.toLowerCase();
                                        if (!val) {
                                            setProductSearchResults([]);
                                            return;
                                        }
                                        const results = allProducts
                                            .filter(p => p.name && p.name.toLowerCase().includes(val))
                                            .slice(0, 5);
                                        setProductSearchResults(results);
                                    }}
                                />
                                {productSearchResults.length > 0 && (
                                    <div className="absolute z-10 w-full mt-1 bg-white border rounded shadow-xl max-h-40 overflow-y-auto">
                                        {productSearchResults.map(p => (
                                            <button
                                                key={p.id}
                                                onClick={() => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        linkedProductId: p.id,
                                                        ctaUrl: `/product/${p.id}`
                                                    }));
                                                    setProductSearchResults([]);
                                                }}
                                                className="w-full text-left px-3 py-2 hover:bg-gray-50 flex items-center gap-2 border-b last:border-0 text-sm"
                                            >
                                                <img src={p.image} className="w-6 h-6 object-contain" alt="" />
                                                <span className="truncate">{p.name}</span>
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="flex items-center gap-3 p-2 bg-blue-50 rounded border border-blue-100">
                                <Check className="w-4 h-4 text-blue-600" />
                                <span className="text-sm font-medium text-blue-800">
                                    Linked: {allProducts.find(p => p.id === formData.linkedProductId)?.name || formData.linkedProductId}
                                </span>
                                <button
                                    onClick={() => setFormData(prev => ({ ...prev, linkedProductId: null, ctaUrl: '/all-products' }))}
                                    className="ml-auto text-xs text-red-500 hover:underline"
                                >
                                    Remove
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="flex items-center gap-4 pt-4">
                        <label className="flex items-center gap-2 cursor-pointer bg-gray-50 px-4 py-2 rounded-lg border">
                            <input
                                type="checkbox"
                                checked={formData.isActive}
                                onChange={e => handleChange('isActive', e.target.checked)}
                                className="w-4 h-4 text-green-600 rounded"
                            />
                            <span className="text-sm font-semibold">Active</span>
                        </label>

                        <div className="flex-1"></div>

                        <button
                            onClick={() => setEditingId(null)}
                            className="px-4 py-2 text-gray-500 hover:text-gray-700 font-medium"
                        >
                            {t('admin.actions.cancel')}
                        </button>
                        <button
                            onClick={handleSave}
                            className="px-6 py-2 bg-green-600 text-white rounded-lg font-bold shadow-md hover:bg-green-700 transition-colors"
                        >
                            {t('admin.actions.save')}
                        </button>
                    </div>
                </div>
            )}

            <div className="space-y-4">
                {campaigns.map((c, index) => (
                    <div key={c.id} className={`bg-white p-4 rounded-xl border flex items-center justify-between transition-opacity ${!c.isActive ? 'opacity-60 grayscale' : ''}`}>
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center text-gray-400">
                                <ImageIcon className="w-6 h-6" />
                            </div>
                            <div>
                                <h4 className="font-bold text-gray-800">{c.title_en} / {c.title_tr}</h4>
                                <div className="flex items-center gap-2 mt-1">
                                    <span className="text-[10px] font-bold px-2 py-0.5 bg-gray-100 rounded text-gray-500 uppercase">{c.isActive ? 'Active' : 'Inactive'}</span>
                                    <span className="text-xs text-gray-400 truncate max-w-[200px]">{c.desc_en}</span>
                                </div>
                            </div>
                        </div>

                        <div className="flex items-center gap-2">
                            {/* Ordering Controls */}
                            <div className="flex flex-col gap-1 mr-2">
                                <button
                                    disabled={index === 0}
                                    onClick={() => {
                                        const newOrder = [...campaigns];
                                        [newOrder[index - 1], newOrder[index]] = [newOrder[index], newOrder[index - 1]];
                                        onChange(newOrder);
                                    }}
                                    className="p-1 hover:bg-gray-100 rounded disabled:opacity-30"
                                >
                                    <span className="text-[10px] font-bold">▲</span>
                                </button>
                                <button
                                    disabled={index === campaigns.length - 1}
                                    onClick={() => {
                                        const newOrder = [...campaigns];
                                        [newOrder[index + 1], newOrder[index]] = [newOrder[index], newOrder[index + 1]];
                                        onChange(newOrder);
                                    }}
                                    className="p-1 hover:bg-gray-100 rounded disabled:opacity-30"
                                >
                                    <span className="text-[10px] font-bold">▼</span>
                                </button>
                            </div>

                            <button onClick={() => handleEdit(c)} className="p-2 hover:bg-blue-50 text-blue-600 rounded-lg">
                                <Edit2 className="w-4 h-4" />
                            </button>
                            <button onClick={() => handleDelete(c.id)} className="p-2 hover:bg-red-50 text-red-600 rounded-lg">
                                <Trash2 className="w-4 h-4" />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CampaignsManager;
